/**
 * Version der App aus dem Wurzel-package.json – beim Build (und im Entwicklungs-Server) von `vite.config.ts` als `__APP_VERSION__`
 * eingesetzt; erhöht wird sie mit `npm run release:*` (siehe RELEASING.md). Ohne Vite (Unit-Tests) gilt „0.0.0“.
 */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';
